<template>
  <v-container fluid>
    <h3 style="text-align:left">Consultez notre Livre Blanc "Risque minier à Varangéville, un Livre Blanc pour écrire l'avenir"</h3>
    <br>
    <div class="d-flex flex-column">
      <v-form v-if="show" ref="form" v-model="valid">
        <v-text-field v-model="lastname" label="Nom" :rules="nameRules" required></v-text-field>
        <v-text-field v-model="firstname" label="Prénom" :rules="nameRules" required></v-text-field>
        <v-text-field v-model="fct" label="Fonction"></v-text-field>
        <v-text-field v-model="firm" label="Société (optionnel)"></v-text-field>
        <v-text-field v-model="mail" label="E-mail" :rules="nameRules" required></v-text-field>

        <v-select
          :items="languages"
          v-model="language"
          item-title="lang"
          item-value="abbr"
          label="Langue"
        ></v-select>

        <v-checkbox
          v-model="accept_conditions"
          :rules="nameRules"
          label="En soumettant ce formulaire, j'accepte que les informations saisies soient exploitées dans le cadre d'une mise en relation avec Selidaire Varangéville"
          required
        ></v-checkbox>

        <v-col cols="11">
          <v-btn :disabled="!valid" color="success" @click="getBook">Obtenir le Livre Blanc</v-btn>
        </v-col>

        <div v-if="errors.length">
          <b>Erreur:</b>
          <ul>
            <li v-for="error in errors" :key="error">{{ error }}</li>
          </ul>
        </div>
        <div v-if="status.length">
          <b>{{ status }}</b>
        </div>
      </v-form>

      <div v-if="docLoaded" id="my_pdf_viewer">
        <div id="canvas_container">
          <canvas style="height:100%" id="pdf_renderer"></canvas>
        </div>
        <div id="navigation_controls">
          <v-btn size="small" @click="prevPage">Page précédente</v-btn>
          <input id="current_page" @keyup="goTo" value="1" type="number" />
          <v-btn size="small" @click="nextPage">Page suivante</v-btn>
          Zoom:
          <v-btn @click="zoomIn" id="zoom_in" size="small">Zoom -</v-btn>
          <v-btn @click="zoomOut" id="zoom_out" size="small">Zoom +</v-btn>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      show: true,
      docLoaded: false,
      valid: false,
      accept_conditions: null,
      errors: [],
      status: [],
      language: 'FR',
      languages: [
        { lang: 'Français', abbr: 'FR' },
        { lang: 'Anglais', abbr: 'EN' }
      ],
      firstname: null,
      lastname: null,
      fct: null,
      mail: null,
      firm: null,
      myState: {
        pdf: null,
        currentPage: 1,
        zoom: 2.5,
      },
      nameRules: [v => !!v || 'required'],
    }
  },
  methods: {
    getBook () {
      this.$refs.form.validate().then(valid => {
        if (!valid) return
        this.errors = []
        this.status = []
        var errs = this.errors
        this.$apiclient.addFollower(
          this.firstname, this.lastname, this.mail,
          this.firm, this.fct, this.accept_conditions, 'WhiteBook'
        )
          .then(response => {
            if (response.status !== 200) errs.push(response.statusText)
            this.show = false
            this.getdoc(this.language)
          })
          .catch(error => {
            if (error.response.status === 401) {
              errs.push("Vous n'êtes pas connecté ou non authorisé")
            } else {
              errs.push(error)
            }
          })
      })
    },
    downloadBook (token) {
      var errs = this.errors
      this.$apiclient.getWhitebook(token)
        .then(response => {
          if (response.status !== 200) errs.push(response.statusText)
          var doc = (response.data != null) ? response.data : null
          if (doc != null) {
            this.docLoaded = true
            // pdfjsLib loaded via CDN in index.html
            /* global pdfjsLib */
            pdfjsLib.getDocument({ data: atob(doc) }).then((pdf) => {
              this.myState.pdf = pdf
              this.render()
            })
          }
        })
        .catch(error => { errs.push(error) })
    },
    getdoc (language) {
      var errs = this.errors
      this.$apiclient.getTokenWhiteBook(language)
        .then(response => {
          if (response.status !== 200) errs.push(response.statusText)
          var token = (response.data != null) ? response.data : null
          this.downloadBook(token)
        })
        .catch(error => { errs.push(error) })
    },
    render () {
      this.myState.pdf.getPage(this.myState.currentPage).then((page) => {
        var container = document.getElementById('my_pdf_viewer')
        var canvas = document.getElementById('pdf_renderer')
        var ctx = canvas.getContext('2d')
        var viewport = page.getViewport({ scale: this.myState.zoom })
        var scale = container.clientWidth / viewport.width
        viewport = page.getViewport({ scale })
        canvas.width = viewport.width
        canvas.height = viewport.height
        page.render({ canvasContext: ctx, viewport })
      })
    },
    prevPage () {
      if (this.myState.pdf == null || this.myState.currentPage === 1) return
      this.myState.currentPage -= 1
      document.getElementById('current_page').value = this.myState.currentPage
      this.render()
    },
    nextPage () {
      if (this.myState.pdf == null || this.myState.currentPage > this.myState.pdf._pdfInfo.numPages) return
      this.myState.currentPage += 1
      document.getElementById('current_page').value = this.myState.currentPage
      this.render()
    },
    goTo (e) {
      if (this.myState.pdf == null) return
      var code = (e.keyCode ? e.keyCode : e.which)
      if (code === 13) {
        var desiredPage = document.getElementById('current_page').valueAsNumber
        if (desiredPage >= 1 && desiredPage <= this.myState.pdf._pdfInfo.numPages) {
          this.myState.currentPage = desiredPage
          document.getElementById('current_page').value = desiredPage
          this.render()
        }
      }
    },
    zoomOut () {
      if (this.myState.pdf == null) return
      this.myState.zoom -= 0.5
      this.render()
    },
    zoomIn () {
      if (this.myState.pdf == null) return
      this.myState.zoom += 0.5
      this.render()
    },
  }
}
</script>
